import React, { FC, RefObject, useState, useEffect } from 'react'
import { Direction, REQUEST_CONFIGS_KEYS } from '@services/constants'
import TextInput from '../inputs/text.inputs'
import RadioInput from '../inputs/radio.input'
import { classes, isBalconySectionA, isBalconySectionB } from './__index.utils'
import { CheckboxList, RadioList, SelectList } from '@utils/request'
import * as utilsList from './__index.utils'
import Notification from '@components/ui/notification'
import CheckboxInput from '../inputs/checkbox.input'
import SelectInput from '../inputs/select.inputs'
import MeasurementInput from '../inputs/measurement.input'
import { joinClasses } from '@utils/styles'
import {
	amenagementBalconDimensions,
	amenagementGalerieDimensions,
	amenagementperronDimensions,
	amenagementporcheDimensions
} from '@images/icons'

const Step4_1LandDevelopmentWork = ({
	pageAssets,
	pageUtils,
	formInputs,
	errors,
	updateInput,
	onFixError,
	isSummaryStep = false,
	// *******
	updateCheckBoxInput
}) => {
	const {
		whatToDo,

		// **********************
		mainUseOfExistingBuilding,
		isResidentialOrOther,
		// ***********************

		typesOfWorkBalcony,
		installationType,
		foundationTypeBalcony,
		locationBalcony,
		widthBalcony,
		widthUnitBalcony,
		depthBalcony,
		depthUnitBalcony,
		heightBalcony,
		heightUnitBalcony,
		areaBalcony,
		areaUnitBalcony,
		structureBalcony,
		roofBalcony,
		foundationTypeTerrace,
		locationTerrace,
		isTerraceInclude,
		heightTerrace,
		heightUnitTerrace,
		areaTerrace,
		areaUnitTerrace,
		wallsTerrace,
		structureTerrace,
		roofTerrace
	} = formInputs

	const [dimensionsWidth, setDimensionsWidth] = useState<string>('82%')
	const diplayOptionDetails = (image) => {
		return (
			<img
				className={classes.image}
				src={image}
				style={{ maxWidth: '280px', height: 'auto' }}
			/>
		)
	}

	useEffect(() => {
		const isKnown =
			installationType.value ===
				REQUEST_CONFIGS_KEYS.installationTypeBalcony.firstOption ||
			installationType.value ===
				REQUEST_CONFIGS_KEYS.installationTypeBalcony.secondOption ||
			installationType.value ===
				REQUEST_CONFIGS_KEYS.installationTypeBalcony.thirdOption ||
			installationType.value ===
				REQUEST_CONFIGS_KEYS.installationTypeBalcony.fourthOption

		setDimensionsWidth(isKnown ? '82%' : '50%')
	}, [installationType.value])

	const renderInstallationDetail = () => {
		if (
			installationType.value ===
			REQUEST_CONFIGS_KEYS.installationTypeBalcony.firstOption
		)
			return diplayOptionDetails(amenagementBalconDimensions)
		if (
			installationType.value ===
			REQUEST_CONFIGS_KEYS.installationTypeBalcony.secondOption
		)
			return diplayOptionDetails(amenagementGalerieDimensions)
		if (
			installationType.value ===
			REQUEST_CONFIGS_KEYS.installationTypeBalcony.thirdOption
		)
			return diplayOptionDetails(amenagementperronDimensions)
		if (
			installationType.value ===
			REQUEST_CONFIGS_KEYS.installationTypeBalcony.fourthOption
		)
			return diplayOptionDetails(amenagementporcheDimensions)

		return null
	}

	const radioListTypesOfWorkBalcony: CheckboxList[] =
		utilsList.radioListTypesOfWorkBalcony(pageAssets)

	const installationTypeBalconyList: RadioList[] =
		utilsList.installationTypeBalconyList(pageAssets, diplayOptionDetails)

	const radioListFoundationTypeBalcony: SelectList[] =
		utilsList.radioListFoundationTypeBalcony(pageAssets)

	const radioListLocationBalcony: SelectList[] = pageUtils
		.radioListPlaceOnTheTerrain(pageAssets)
		.slice(0, 6)

	const radioListMeasurementUnit: RadioList[] =
		utilsList.radioListMeasurementUnit(pageAssets)

	const radioListMeasurement2Unit: RadioList[] =
		utilsList.radioListMeasurement2Unit(pageAssets)

	const radioListFoundationTypeTerrace: SelectList[] = [
		...pageUtils.radioListFoundationTypeBalcony(pageAssets).slice(0, 3),
		{
			label: pageAssets?.request_form_select_label_other,
			value: REQUEST_CONFIGS_KEYS.fondationTypeBalcony.thirdOption,
			key: 'request_form_select_label_other'
		}
	]

	const radioListLocationTerrace: SelectList[] = [
		...pageUtils.radioListPlaceOnTheTerrain(pageAssets).slice(0, 6),
		{
			label: pageAssets?.request_form_select_label_other,
			value: REQUEST_CONFIGS_KEYS.placeOnTheTerrain.sixthOption,
			key: 'request_form_select_label_other'
		}
	]

	const radioListIsTerraceInclude: CheckboxList[] =
		utilsList.radioListIsTerraceInclude(pageAssets)

	return (
		<>
			{/* typesOfWorkBalconyInput */}

			<CheckboxInput
				name={typesOfWorkBalcony.name}
				label={typesOfWorkBalcony.label}
				description={typesOfWorkBalcony.description}
				value={`${typesOfWorkBalcony.value}`}
				list={radioListTypesOfWorkBalcony}
				onChange={(value) => updateCheckBoxInput(typesOfWorkBalcony, value)}
				required={typesOfWorkBalcony.required}
				hasError={errors.includes(typesOfWorkBalcony.name)}
				ref={typesOfWorkBalcony.ref as RefObject<HTMLInputElement>}
				errors={errors}
				shouldNotDivide
				hasBackgroundWrapper
				onFixError={onFixError}
				newCheckValue
				isSummaryStep={isSummaryStep}
			/>

			{/* Section A */}
			{isBalconySectionA(typesOfWorkBalcony.value) && (
				<>
					<h5 className={pageUtils.classes.h5}>
						{
							pageAssets?.request_form_landDevWorkPermit_typesOfWorkBalcony_firstOption
						}
					</h5>

					{[
						REQUEST_CONFIGS_KEYS.mainUseOfExistingBuilding.firstOption,
						REQUEST_CONFIGS_KEYS.mainUseOfExistingBuilding.thirdOption
					].includes(mainUseOfExistingBuilding.value) && (
						<>
							<RadioInput
								name={installationType.name}
								label={installationType.label}
								value={installationType.value}
								list={installationTypeBalconyList}
								direction={Direction.vertical}
								hasError={errors!.includes(installationType.name)}
								onChange={(value) => updateInput(installationType.name, value)}
								ref={installationType.ref as RefObject<HTMLInputElement>}
								required={installationType.required}
								hasBackgroundWrapper={true}
								alternateDisplay={true}
								isSummaryStep={isSummaryStep}
							/>

							<SelectInput
								id={foundationTypeBalcony.name}
								label={foundationTypeBalcony.label}
								value={foundationTypeBalcony.value}
								list={radioListFoundationTypeBalcony}
								hasError={errors!.includes(foundationTypeBalcony.name)}
								onChange={(value) =>
									updateInput(foundationTypeBalcony.name, value)
								}
								ref={foundationTypeBalcony.ref as RefObject<HTMLSelectElement>}
								required={foundationTypeBalcony.required}
								isSummaryStep={isSummaryStep}
							/>
							{!isSummaryStep &&
								foundationTypeBalcony.value ==
									radioListFoundationTypeBalcony[3].value && (
									<Notification
										text={
											pageAssets?.request_form_buildingConstructionOrAdditionPermit_foundationTypeBalcony_notification
										}
										type="info"
										hasHtml
									/>
								)}
						</>
					)}

					<SelectInput
						id={locationBalcony.name}
						label={locationBalcony.label}
						value={locationBalcony.value}
						list={radioListLocationBalcony}
						hasError={errors!.includes(locationBalcony.name)}
						onChange={(value) => updateInput(locationBalcony.name, value)}
						ref={locationBalcony.ref as RefObject<HTMLSelectElement>}
						required={locationBalcony.required}
						isSummaryStep={isSummaryStep}
					/>
					{[
						REQUEST_CONFIGS_KEYS.mainUseOfExistingBuilding.firstOption,
						REQUEST_CONFIGS_KEYS.mainUseOfExistingBuilding.thirdOption
					].includes(mainUseOfExistingBuilding.value) && (
						<>
							{(!isSummaryStep ||
								(isSummaryStep &&
									(widthBalcony.value ||
										depthBalcony.value ||
										heightBalcony.value ||
										areaBalcony.value))) && (
								<h6 className={classes.h6}>
									{
										pageAssets?.request_form_buildingConstructionOrAdditionPermit_dimensions
									}
								</h6>
							)}
							
              <div className={pageUtils.classes.flexContainer}>
								<div className={pageUtils.classes.leftColumn}>
									<div style={{ width: dimensionsWidth }}>
										<MeasurementInput
											measurementInput={widthBalcony}
											unitInput={widthUnitBalcony}
											listMeasurementUnit={radioListMeasurementUnit}
											maxCharacters={6}
											isSummaryStep={isSummaryStep}
											errors={errors}
											onFixError={onFixError}
											updateInput={updateInput}
											hasError={errors?.includes(widthBalcony.name)}
											reducedMargin
										/>
									</div>

									<div style={{ width: dimensionsWidth  }}>
                    {/* depthBalconyInput */}
										<MeasurementInput
											measurementInput={depthBalcony}
											unitInput={depthUnitBalcony}
											listMeasurementUnit={radioListMeasurementUnit}
											maxCharacters={6}
											isSummaryStep={isSummaryStep}
											errors={errors}
											onFixError={onFixError}
											updateInput={updateInput}
											hasError={errors?.includes(depthBalcony.name)}
											reducedMargin
										/>
									</div>

									<div style={{ width: dimensionsWidth }}>
										{/* heightBalconyInput*/}
										<MeasurementInput
											measurementInput={heightBalcony}
											unitInput={heightUnitBalcony}
											listMeasurementUnit={radioListMeasurementUnit}
											maxCharacters={6}
											isSummaryStep={isSummaryStep}
											errors={errors}
											onFixError={onFixError}
											updateInput={updateInput}
											hasError={errors?.includes(heightBalcony.name)}
											reducedMargin
										/>
									</div>
									<div style={{ width: dimensionsWidth }}>
                    {/* areaBalconyInput */}
										<MeasurementInput
											measurementInput={areaBalcony}
											unitInput={areaUnitBalcony}
											listMeasurementUnit={radioListMeasurement2Unit}
											maxCharacters={12}
											isSummaryStep={isSummaryStep}
											errors={errors}
											onFixError={onFixError}
											updateInput={updateInput}
											hasError={errors?.includes(areaBalcony.name)}
											reducedMargin
										/>
									</div>
								</div>
								<div className={pageUtils.classes.rightColumn}>
									{!isSummaryStep && renderInstallationDetail()}
								</div>
							</div>

							{(!isSummaryStep ||
								(isSummaryStep &&
									(structureBalcony.value || roofBalcony.value))) && (
								<h6 className={classes.h6}>
									{
										pageAssets?.request_form_buildingConstructionOrAdditionPermit_materials
									}
								</h6>
							)}
							{/* structureBalconyInput */}
							<TextInput
								id={structureBalcony.name}
								label={structureBalcony.label}
								value={structureBalcony.value}
								onChange={(value) => updateInput(structureBalcony.name, value)}
								hasError={errors.includes(structureBalcony.name)}
								required={structureBalcony.required}
								ref={structureBalcony.ref as RefObject<HTMLInputElement>}
								maxCharacters={50}
								isSummaryStep={isSummaryStep}
							/>
							{/* roofBalconyInput
							 */}
							<TextInput
								id={roofBalcony.name}
								label={roofBalcony.label}
								value={roofBalcony.value}
								onChange={(value) => updateInput(roofBalcony.name, value)}
								hasError={errors.includes(roofBalcony.name)}
								required={roofBalcony.required}
								ref={roofBalcony.ref as RefObject<HTMLInputElement>}
								maxCharacters={50}
								isSummaryStep={isSummaryStep}
							/>
						</>
					)}
				</>
			)}

			{/* Section B  */}
			{isBalconySectionB(typesOfWorkBalcony.value) && (
				<>
					<h5 className={pageUtils.classes.h5}>
						{
							pageAssets?.request_form_landDevWorkPermit_typesOfWorkBalcony_secondOption
						}
					</h5>

					{!isSummaryStep && (
						<Notification
							text={
								pageAssets?.request_form_buildingConstructionOrAdditionPermit_typesOfWorkBalcony_commercialUse_notification
							}
							type="info"
							hasHtml
						/>
					)}

					<SelectInput
						id={foundationTypeTerrace.name}
						label={foundationTypeTerrace.label}
						value={foundationTypeTerrace.value}
						list={radioListFoundationTypeTerrace}
						hasError={errors!.includes(foundationTypeTerrace.name)}
						onChange={(value) => updateInput(foundationTypeTerrace.name, value)}
						ref={foundationTypeTerrace.ref as RefObject<HTMLSelectElement>}
						required={foundationTypeTerrace.required}
						isSummaryStep={isSummaryStep}
					/>

					<SelectInput
						id={locationTerrace.name}
						label={locationTerrace.label}
						value={locationTerrace.value}
						list={radioListLocationTerrace}
						hasError={errors!.includes(locationTerrace.name)}
						onChange={(value) => updateInput(locationTerrace.name, value)}
						ref={locationTerrace.ref as RefObject<HTMLSelectElement>}
						required={locationTerrace.required}
						isSummaryStep={isSummaryStep}
					/>

					{isResidentialOrOther.value ==
						REQUEST_CONFIGS_KEYS.isResidentialOrOther.firstOption && (
						<CheckboxInput
							name={isTerraceInclude.name}
							label={isTerraceInclude.label}
							description={isTerraceInclude.description}
							value={`${isTerraceInclude.value}`}
							list={radioListIsTerraceInclude}
							onChange={(value) => updateCheckBoxInput(isTerraceInclude, value)}
							required={isTerraceInclude.required}
							hasError={errors.includes(isTerraceInclude.name)}
							ref={isTerraceInclude.ref as RefObject<HTMLInputElement>}
							errors={errors}
							shouldNotDivide
							hasBackgroundWrapper
							onFixError={onFixError}
							newCheckValue
							isSummaryStep={isSummaryStep}
						/>
					)}

					{(!isSummaryStep ||
						(isSummaryStep && (heightTerrace.value || areaTerrace.value))) && (
						<h6 className={classes.h6}>
							{
								pageAssets?.request_form_buildingConstructionOrAdditionPermit_dimensions
							}
						</h6>
					)}

					<div
						className={joinClasses([
							pageUtils.classes.fieldsContainer,
							'fieldsContainer'
						])}
					>
						<MeasurementInput
							measurementInput={heightTerrace}
							unitInput={heightUnitTerrace}
							listMeasurementUnit={radioListMeasurementUnit}
							maxCharacters={6}
							isSummaryStep={isSummaryStep}
							errors={errors}
							onFixError={onFixError}
							updateInput={updateInput}
							hasError={errors?.includes(heightTerrace.name)}
							reducedMargin
						/>
						<MeasurementInput
							measurementInput={areaTerrace}
							unitInput={areaUnitTerrace}
							listMeasurementUnit={radioListMeasurement2Unit}
							maxCharacters={12}
							isSummaryStep={isSummaryStep}
							errors={errors}
							onFixError={onFixError}
							updateInput={updateInput}
							hasError={errors?.includes(areaTerrace.name)}
							reducedMargin
						/>
					</div>

					{(!isSummaryStep ||
						(isSummaryStep &&
							(wallsTerrace.value ||
								structureTerrace.value ||
								roofTerrace.value))) && (
						<h6 className={classes.h6}>
							{
								pageAssets?.request_form_buildingConstructionOrAdditionPermit_materials
							}
						</h6>
					)}

					{/* structureBalconyInput */}
					<TextInput
						id={wallsTerrace.name}
						label={wallsTerrace.label}
						value={wallsTerrace.value}
						onChange={(value) => updateInput(wallsTerrace.name, value)}
						hasError={errors.includes(wallsTerrace.name)}
						required={wallsTerrace.required}
						ref={wallsTerrace.ref as RefObject<HTMLInputElement>}
						maxCharacters={50}
						isSummaryStep={isSummaryStep}
					/>
					{/* structureTerraceInput */}
					<TextInput
						id={structureTerrace.name}
						label={structureTerrace.label}
						value={structureTerrace.value}
						onChange={(value) => updateInput(structureTerrace.name, value)}
						hasError={errors.includes(structureTerrace.name)}
						required={structureTerrace.required}
						ref={structureTerrace.ref as RefObject<HTMLInputElement>}
						maxCharacters={50}
						isSummaryStep={isSummaryStep}
					/>
					{/* roofTerraceInput */}
					<TextInput
						id={roofTerrace.name}
						label={roofTerrace.label}
						value={roofTerrace.value}
						onChange={(value) => updateInput(roofTerrace.name, value)}
						hasError={errors.includes(roofTerrace.name)}
						required={roofTerrace.required}
						ref={roofTerrace.ref as RefObject<HTMLInputElement>}
						maxCharacters={50}
						isSummaryStep={isSummaryStep}
					/>
				</>
			)}
		</>
	)
}

export default Step4_1LandDevelopmentWork
